/**
 * LenisController
 * スムーズスクロールを管理する
 */
export const LenisController = {
  lenis: null,

  init() {
    if ( typeof Lenis === 'undefined' ) return;

    this.lenis = new Lenis( {
      duration: 1.2,
      easing: ( t ) => Math.min( 1, 1.001 - Math.pow( 2, -10 * t ) ),
    } );

    // ★ Lenis と ScrollTrigger を同期させる
    // 通常の window scroll イベントが発火しないため、ScrollTrigger.update を明示的に呼ぶ
    if ( typeof ScrollTrigger !== 'undefined' ) {
      this.lenis.on( 'scroll', ScrollTrigger.update );
    }

    const raf = ( time ) => {
      this.lenis.raf( time );
      requestAnimationFrame( raf );
    };
    requestAnimationFrame( raf );
  },

  stop()  { this.lenis?.stop(); },
  start() { this.lenis?.start(); },
};
